module.exports = __webpack_public_path__ + "static/media/ic_info_grey.1be80508.svg";